/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Meeesh API
 * The Meeesh API

Rate limiting:
- default: 60 requests/min (applies to all routes).
- write: 60 requests/min (applies to POST/PUT/PATCH/DELETE).
- public: 120 requests/min (applies only to redirect tracker).

Some endpoints may set stricter write limits (e.g., earn start/claim).
On limit, the API returns 429 with a single Retry-After (seconds).
For redirect, clients can include X-Device-Id to ensure device-keyed limits.
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OverwriteAvatarDto,
  ProfileDto,
  ProfilesControllerDeleteAvatar429,
  ProfilesControllerGetMe429,
  ProfilesControllerGetUserProfile429,
  ProfilesControllerOverwriteAvatar429,
  ProfilesControllerUpdateMe429,
  UpdateProfileDto
} from '.././model';

import { fetcher } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns display name (snapshot from profile), avatar, bio, reaction stats, donation stats, and active dream (if any).
 * @summary Get current user profile (aggregated)
 */
export const profilesControllerGetMe = (
    
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ProfileDto>(
      {url: `/profiles/me`, method: 'GET', signal
    },
      options);
    }
  

export const getProfilesControllerGetMeQueryKey = () => {
    return [`/profiles/me`] as const;
    }

    
export const getProfilesControllerGetMeQueryOptions = <TData = Awaited<ReturnType<typeof profilesControllerGetMe>>, TError = null | ProfilesControllerGetMe429>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfilesControllerGetMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof profilesControllerGetMe>>> = ({ signal }) => profilesControllerGetMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProfilesControllerGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof profilesControllerGetMe>>>
export type ProfilesControllerGetMeQueryError = null | ProfilesControllerGetMe429


export function useProfilesControllerGetMe<TData = Awaited<ReturnType<typeof profilesControllerGetMe>>, TError = null | ProfilesControllerGetMe429>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof profilesControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof profilesControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfilesControllerGetMe<TData = Awaited<ReturnType<typeof profilesControllerGetMe>>, TError = null | ProfilesControllerGetMe429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof profilesControllerGetMe>>,
          TError,
          Awaited<ReturnType<typeof profilesControllerGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfilesControllerGetMe<TData = Awaited<ReturnType<typeof profilesControllerGetMe>>, TError = null | ProfilesControllerGetMe429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user profile (aggregated)
 */

export function useProfilesControllerGetMe<TData = Awaited<ReturnType<typeof profilesControllerGetMe>>, TError = null | ProfilesControllerGetMe429>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetMe>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfilesControllerGetMeQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update name override and bio
 */
export const profilesControllerUpdateMe = (
    updateProfileDto: UpdateProfileDto,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ProfileDto>(
      {url: `/profiles/me`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProfileDto
    },
      options);
    }
  


export const getProfilesControllerUpdateMeMutationOptions = <TError = null | ProfilesControllerUpdateMe429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profilesControllerUpdateMe>>, TError,{data: UpdateProfileDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof profilesControllerUpdateMe>>, TError,{data: UpdateProfileDto}, TContext> => {

const mutationKey = ['profilesControllerUpdateMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof profilesControllerUpdateMe>>, {data: UpdateProfileDto}> = (props) => {
          const {data} = props ?? {};

          return  profilesControllerUpdateMe(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProfilesControllerUpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof profilesControllerUpdateMe>>>
    export type ProfilesControllerUpdateMeMutationBody = UpdateProfileDto
    export type ProfilesControllerUpdateMeMutationError = null | ProfilesControllerUpdateMe429

    /**
 * @summary Update name override and bio
 */
export const useProfilesControllerUpdateMe = <TError = null | ProfilesControllerUpdateMe429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profilesControllerUpdateMe>>, TError,{data: UpdateProfileDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof profilesControllerUpdateMe>>,
        TError,
        {data: UpdateProfileDto},
        TContext
      > => {

      const mutationOptions = getProfilesControllerUpdateMeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Set or replace custom avatar.
 */
export const profilesControllerOverwriteAvatar = (
    overwriteAvatarDto: OverwriteAvatarDto,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ProfileDto>(
      {url: `/profiles/me/avatar`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: overwriteAvatarDto
    },
      options);
    }
  


export const getProfilesControllerOverwriteAvatarMutationOptions = <TError = null | ProfilesControllerOverwriteAvatar429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profilesControllerOverwriteAvatar>>, TError,{data: OverwriteAvatarDto}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof profilesControllerOverwriteAvatar>>, TError,{data: OverwriteAvatarDto}, TContext> => {

const mutationKey = ['profilesControllerOverwriteAvatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof profilesControllerOverwriteAvatar>>, {data: OverwriteAvatarDto}> = (props) => {
          const {data} = props ?? {};

          return  profilesControllerOverwriteAvatar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProfilesControllerOverwriteAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof profilesControllerOverwriteAvatar>>>
    export type ProfilesControllerOverwriteAvatarMutationBody = OverwriteAvatarDto
    export type ProfilesControllerOverwriteAvatarMutationError = null | ProfilesControllerOverwriteAvatar429

    /**
 * @summary Set or replace custom avatar.
 */
export const useProfilesControllerOverwriteAvatar = <TError = null | ProfilesControllerOverwriteAvatar429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profilesControllerOverwriteAvatar>>, TError,{data: OverwriteAvatarDto}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof profilesControllerOverwriteAvatar>>,
        TError,
        {data: OverwriteAvatarDto},
        TContext
      > => {

      const mutationOptions = getProfilesControllerOverwriteAvatarMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Delete custom avatar.
 */
export const profilesControllerDeleteAvatar = (
    
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<ProfileDto>(
      {url: `/profiles/me/avatar`, method: 'DELETE'
    },
      options);
    }
  


export const getProfilesControllerDeleteAvatarMutationOptions = <TError = null | ProfilesControllerDeleteAvatar429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profilesControllerDeleteAvatar>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof profilesControllerDeleteAvatar>>, TError,void, TContext> => {

const mutationKey = ['profilesControllerDeleteAvatar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof profilesControllerDeleteAvatar>>, void> = () => {
          

          return  profilesControllerDeleteAvatar(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProfilesControllerDeleteAvatarMutationResult = NonNullable<Awaited<ReturnType<typeof profilesControllerDeleteAvatar>>>
    
    export type ProfilesControllerDeleteAvatarMutationError = null | ProfilesControllerDeleteAvatar429

    /**
 * @summary Delete custom avatar.
 */
export const useProfilesControllerDeleteAvatar = <TError = null | ProfilesControllerDeleteAvatar429,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profilesControllerDeleteAvatar>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof profilesControllerDeleteAvatar>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getProfilesControllerDeleteAvatarMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Returns profile information (display name, avatar, bio, reaction stats, donation stats, and active dream if publicly visible) for any user by their ID.
 * @summary Get user profile by ID
 */
export const profilesControllerGetUserProfile = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ProfileDto>(
      {url: `/profiles/${userId}`, method: 'GET', signal
    },
      options);
    }
  

export const getProfilesControllerGetUserProfileQueryKey = (userId?: string,) => {
    return [`/profiles/${userId}`] as const;
    }

    
export const getProfilesControllerGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError = null | ProfilesControllerGetUserProfile429>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProfilesControllerGetUserProfileQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>> = ({ signal }) => profilesControllerGetUserProfile(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: Infinity, retry: 1, retryDelay: 3000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProfilesControllerGetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>>
export type ProfilesControllerGetUserProfileQueryError = null | ProfilesControllerGetUserProfile429


export function useProfilesControllerGetUserProfile<TData = Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError = null | ProfilesControllerGetUserProfile429>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof profilesControllerGetUserProfile>>,
          TError,
          Awaited<ReturnType<typeof profilesControllerGetUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfilesControllerGetUserProfile<TData = Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError = null | ProfilesControllerGetUserProfile429>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof profilesControllerGetUserProfile>>,
          TError,
          Awaited<ReturnType<typeof profilesControllerGetUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProfilesControllerGetUserProfile<TData = Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError = null | ProfilesControllerGetUserProfile429>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user profile by ID
 */

export function useProfilesControllerGetUserProfile<TData = Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError = null | ProfilesControllerGetUserProfile429>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof profilesControllerGetUserProfile>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProfilesControllerGetUserProfileQueryOptions(userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



